'use strict';

const SELECTOR = '.js-header-video';

const isReducedMotion = (
    window.matchMedia(`(prefers-reduced-motion: reduce)`) === true ||
    window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true
);

export function init() {
    for (const headerElement of document.querySelectorAll(SELECTOR)) {
        const iframeElement = headerElement.querySelector('.brightcove-iframe');

        if (!iframeElement) {
            continue;
        }

        const playPauseElements = document.querySelectorAll('.page-hero__pause');

        const iframeWindow = iframeElement.contentWindow;

        let player = null;
        let isPlaying = false;

        const getPlayer = () => {
            if (iframeWindow.videojs) {
                const video = iframeWindow.document.querySelector('video');

                if (video) {
                    player = iframeWindow.videojs(video);
                    setupPlayerEvents();
                }
            } else if (iframeWindow.bc) {
                player = iframeWindow.bc();
                setupPlayerEvents();
            }
        }

        const setupPlayerEvents = () => {
            if (!player) {
                return;
            }

            player.on('play', () => {
                isPlaying = true;
                updatePlayPauseElements();
            });

            player.on('pause', () => {
                isPlaying = false;
                updatePlayPauseElements();
            });

            player.on('loadedmetadata', () => {
                const toggleClass = headerElement.dataset.headerVideoToggleClass || 'header__video--loaded';

                headerElement.classList.add(toggleClass);

                if (!isReducedMotion) {
                    player.play().catch(error => {
                        console.log('Autoplay prevented:', error);
                    });
                }
            });
        }

        for (const element of playPauseElements) {
            element.addEventListener('click', () => {
                if (isPlaying) {
                    player.pause();
                } else {
                    player.play();
                }
            });
        }

        const updatePlayPauseElements = () => {
            const iconHTML = isPlaying
                ? '<svg class="o-icon o-icon--circle-pause"><use xlink:href="#circle-pause"></use></svg>'
                : '<svg class="o-icon o-icon--play-circle"><use xlink:href="#play-circle"></use></svg>';

            const label = isPlaying ? 'Pause' : 'Play';

            for (const element of playPauseElements) {
                element.querySelector('div').innerHTML = iconHTML;
                element.querySelector('span').textContent = label;
                element.classList.toggle('paused');
            }
        }

        if (iframeElement.contentDocument && iframeElement.contentDocument.readyState === 'complete') {
            getPlayer();
        } else {
            iframeElement.addEventListener('load', getPlayer);
        }
    }
}
